import { createEnum } from '@/utils';

export const PLAN = createEnum({
  FREE: 'FREE',
  TRIAL: 'TRIAL',
  PREMIUM: 'PREMIUM',
  SUSPENDED: 'SUSPENDED',
});
